import React from "react";
import Footer from '../Components/Footer.jsx';

const NotFound = () => {
    return (
        <div className="container">
            <h1>NotFound</h1>
            <Footer/>
        </div>
    );
};

export default NotFound;